<div class="import-preview">

  <!-- Validation errors block applying -->
  <div *ngIf="hasErrors" class="mb-3">
    <h3 class="text-700">Problems found ({{ diff.errors.length }})</h3>
    <ul class="app-text-overdue">
      <li *ngFor="let error of diff.errors">{{ error }}</li>
    </ul>
    <small class="text-400">Fix these in the spreadsheet and upload again.</small>
  </div>

  <!-- Non-blocking warnings — surfaced but do NOT prevent applying -->
  <div *ngIf="hasWarnings" class="mb-3">
    <h3 class="text-700">Warnings ({{ diff.warnings.length }})</h3>
    <ul class="app-text-nearing">
      <li *ngFor="let warning of diff.warnings">{{ warning }}</li>
    </ul>
    <small class="text-400">These rows were left unchanged. You can still apply the other changes.</small>
  </div>

  <div *ngIf="!hasErrors && !hasChanges && !hasWarnings" class="text-600">
    No changes detected — the spreadsheet matches the current data.
  </div>

  <!-- Business details -->
  <div *ngIf="diff.business.length" class="mb-3">
    <h3 class="text-700">Business details ({{ diff.business.length }})</h3>
    <table class="w-full preview-table">
      <thead>
        <tr><th>Field</th><th>Before</th><th>After</th></tr>
      </thead>
      <tbody>
        <tr *ngFor="let change of diff.business">
          <td>{{ change.label }}</td>
          <td class="text-500">{{ change.previous || '—' }}</td>
          <td class="text-900">{{ change.next || '—' }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- New products: show every value -->
  <div *ngIf="diff.created.length" class="mb-3">
    <h3 class="text-700">New items ({{ diff.created.length }})</h3>
    <table class="w-full preview-table">
      <thead>
        <tr>
          <th>Type</th><th>Name</th><th>Category</th><th>Cost</th>
          <th>Bespoke</th><th>Invoice Label</th><th>Description</th><th>Note</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let change of diff.created">
          <td>{{ change.label }}</td>
          <td>{{ formatValue('name', change.row.name) }}</td>
          <td>{{ formatValue('category', change.row.category) }}</td>
          <td>{{ formatValue('cost', change.row.cost) }}</td>
          <td>{{ formatValue('bespoke', change.row.bespoke) }}</td>
          <td>{{ formatValue('invoiceLabel', change.row.invoiceLabel) }}</td>
          <td>{{ formatValue('description', change.row.description) }}</td>
          <td>{{ formatValue('note', change.row.note) }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Updated products: per-field before -> after for what changed -->
  <div *ngIf="diff.updated.length" class="mb-3">
    <h3 class="text-700">Updated items ({{ diff.updated.length }})</h3>
    <table class="w-full preview-table">
      <thead>
        <tr><th>Type</th><th>Item</th><th>Changes</th></tr>
      </thead>
      <tbody>
        <tr *ngFor="let change of diff.updated">
          <td>{{ change.label }}</td>
          <td>{{ change.row.name }}</td>
          <td>
            <div *ngFor="let fc of fieldChanges(change)" class="field-change">
              <span class="field-change-label">{{ fc.label }}:</span>
              <span class="text-500">{{ fc.before }}</span>
              <span class="field-change-arrow">&rarr;</span>
              <span class="text-900">{{ fc.after }}</span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Deletions: each defaults ON (honour the sheet); switch off any to keep -->
  <div *ngIf="deleteRows.length" class="mb-3">
    <h3 class="app-text-overdue">Items to delete ({{ deleteRows.length }})</h3>
    <small class="text-400 block mb-2">
      These were marked <strong>Delete? = Yes</strong>. They will be deleted when you apply. Switch off any you want to keep.
    </small>
    <table class="w-full preview-table">
      <thead>
        <tr>
          <th style="width:6rem">Delete</th><th>Type</th><th>Name</th><th>Category</th><th>Cost</th>
          <th>Bespoke</th><th>Invoice Label</th><th>Description</th><th>Note</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of deleteRows" [ngClass]="{ 'delete-selected': row.selected }">
          <td><p-inputSwitch [(ngModel)]="row.selected"></p-inputSwitch></td>
          <td>{{ row.change.label }}</td>
          <td>{{ formatValue('name', row.change.row.name) }}</td>
          <td>{{ formatValue('category', row.change.row.category) }}</td>
          <td>{{ formatValue('cost', row.change.row.cost) }}</td>
          <td>{{ formatValue('bespoke', row.change.row.bespoke) }}</td>
          <td>{{ formatValue('invoiceLabel', row.change.row.invoiceLabel) }}</td>
          <td>{{ formatValue('description', row.change.row.description) }}</td>
          <td>{{ formatValue('note', row.change.row.note) }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="flex justify-content-end gap-2 pt-3 border-top-1 surface-border">
    <button pButton type="button" label="Cancel" class="p-button-text" (click)="onCancel()"></button>
    <button
      pButton
      type="button"
      [label]="selectedDeleteCount ? 'Apply changes (' + selectedDeleteCount + ' to delete)' : 'Apply changes'"
      [disabled]="hasErrors || !hasChanges"
      [ngClass]="{ 'p-button-danger': selectedDeleteCount > 0 }"
      (click)="onApply()"
    ></button>
  </div>

</div>
